@if (label()) {
  <div class="search-field-label">{{ label() }}</div>
}
<neo-input-search
  [searchValue]="value"
  [placeholder]="placeholder()"
  [disabled]="disabled"
  [attr.aut-id]="autId()"
  [attr.aria-label]="ariaLabel() || label() || placeholder() || null"
  (searchChanged)="onSearchChange($event)"
  (clearClicked)="onClearSearch()"
/>
